import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ConfirmDialog } from "primereact/confirmdialog";
import * as moderatorActions from "src/store/actions/Moderator/moderatoractions";
import "src/Assets/css/Moderator/ModeratorHeader.css";

const ConfirmDialogDemo = (props) => {
  const dispatch = useDispatch();
  const {
    isBlockConfirmationModalOpen,
    onCloseUnBlockConfirmationModal,
    warnOrBlockUserId,
    tenantId,
  } = props;

  const moderatingCommunitysData = useSelector(
    (state) => state.ModeratorReducer.moderatingCommunitysData
  );

  const [isBlockusers, setBlockusersArray] = useState([]);

  useEffect(() => {
    let BlockUsers = [];
    if (
      moderatingCommunitysData &&
      Object.keys(moderatingCommunitysData).length !== 0
    ) {
      // moderatingCommunitysData.restrictions.filter(restrictions => restrictions.isPm === "1").map(moderatorId =>
      //   BlockUsers.push(moderatorId.tenantId)
      // );
      BlockUsers = moderatingCommunitysData.restrictions
        .filter((restrictions) => restrictions.isPm === "1")
        .map((moderatorId) => moderatorId.tenantId);

      setBlockusersArray([...isBlockusers, BlockUsers]);
    }
  }, [moderatingCommunitysData]);

  const accept = () => {
    if (tenantId) {
      dispatch(
        moderatorActions.fetchBlockMembersData(
          `?tenantId=${tenantId}&selectedIds=${warnOrBlockUserId}`
        )
      );
      dispatch(moderatorActions.fetchManageMembersData(tenantId));
      props?.onRefreshMembersData();
      onCloseUnBlockConfirmationModal();
    }
    // document.getElementById(id);
  };

  return (
    <div>
      <div className="custom-confirm-dialog">
        <ConfirmDialog />
        <ConfirmDialog
          className="custom-confirm-dialog"
          visible={isBlockConfirmationModalOpen}
          onHide={() => onCloseUnBlockConfirmationModal()}
          message={`Are you sure you want to Unblock the user?`}
          header="Unblock users confirmation"
          accept={accept}
        />
      </div>
    </div>
  );
};

export default ConfirmDialogDemo;
